import React from "react";
import { useNotification } from "@stonelog/stonelog-design-system";
import { GingaIcon } from "@stonelog/stonelog-ginga-icons";

// Snackbar escuro do design system (o mesmo do "Etiqueta impressa com sucesso!").
// Precisa estar dentro de um <NotificationProvider>.
export const useNotify = () => {
  const { addNotification } = useNotification();

  const notify = (iconName, text) =>
    addNotification({
      icon: <GingaIcon name={iconName} color="#fff" size={20} />,
      text,
      position: "bottom-center",
      closable: true,
    });

  return {
    success: (text) => notify("solid-check-round", text),
    error: (text) => notify("round-error", text),
    info: (text) => notify("round-info", text),
  };
};
